// A differenza di StatoScadenzaMezzo/StatoManutenzione non c'è un flusso
// Pianificata/InCorso/Completata: un contenuto di sicurezza è solo Attivo
// (non ancora sostituito) o Sostituito. "Scaduto"/"In scadenza" arrivano già
// calcolati dal backend (EffettivamenteScaduto/InScadenza), non vanno
// ricalcolati lato client.
export function coloreRigaContenuto(item) {
    if (!item) return "grey";
    if (item.sostituito) return "info";
    if (item.effettivamenteScaduto) return "error";
    if (item.inScadenza) return "warning";
    return "success";
}

export function etichettaRigaContenuto(item) {
    if (!item) return "";
    if (item.sostituito) return "Sostituito";
    if (item.effettivamenteScaduto) return "Scaduto";
    if (item.inScadenza) return "In scadenza";
    return "Attivo";
}
